import axios from '@/api/axios';
import { SPORT_LIVE_TV_EVENTS_LIMIT, SPORT_LIVE_TV_SEARCH_LIMIT } from '@/sport-live-tv/constants';
import { clampSportLiveTvLimit } from '@/sport-live-tv/helpers';

export const getSportLiveTvCategories = async (status, offset, limit) => {
  const { data } = await axios.get('/api/info/sport-livetv/categories', { params: { offset, limit: clampSportLiveTvLimit(limit), status } });

  return data.data;
};

export const getSportLiveTvCategoryEvents = async ({ categoryId, offset, limit, status, teams = [] }) => {
  const { data } = await axios.get(`/api/info/sport-livetv/categories/${categoryId}/events`, {
    params: { offset, limit: clampSportLiveTvLimit(limit), status, ...(teams.length && { teams }) },
  });

  return data.data;
};

export const getSportLiveTvCategoriesEventsPage = async ({ categoryIds, teams = [], status, offset, limit }) => {
  const pageLimit = clampSportLiveTvLimit(limit);
  const pages = await Promise.all(categoryIds.map((categoryId) => getSportLiveTvCategoryEvents({ categoryId, offset, limit: pageLimit, status, teams })));

  return { events: pages.flat(), hasMore: pages.some((page) => page.length === pageLimit) };
};

export const getPopularSportLiveTvEvents = async (offset, limit) => {
  const { data } = await axios.get(`/api/popular/sport-livetv-event/${offset}/${clampSportLiveTvLimit(limit)}`);

  return data.data;
};

export const getSportLiveTvTeams = async (search, offset, limit) => {
  const { data } = await axios.get('/api/info/sport-livetv/teams', { params: { offset, limit: clampSportLiveTvLimit(limit), ...(search && { q: search }) } });

  return data.data;
};

export const searchSportLiveTvEvents = async (keyword, limit) => {
  const { data } = await axios.get(`/api/info/sport-livetv-event/search/${encodeURIComponent(keyword)}/${clampSportLiveTvLimit(limit)}`);

  return data.data;
};

const fetchLeaguesPage = async ({ leagues, teams }, status, loadedEvents, offset) => {
  const { events, hasMore } = await getSportLiveTvCategoriesEventsPage({ categoryIds: leagues, teams, status, offset, limit: SPORT_LIVE_TV_EVENTS_LIMIT });

  return { events: [...loadedEvents, ...events], hasNextPage: hasMore, nextOffset: offset + SPORT_LIVE_TV_EVENTS_LIMIT };
};

const fetchSingleTeamPage = async (team, loadedEvents) => {
  const limit = loadedEvents.length + SPORT_LIVE_TV_SEARCH_LIMIT;
  const events = await searchSportLiveTvEvents(team, limit);

  return { events, hasNextPage: events.length === limit, nextOffset: 0 };
};

const fetchMultiTeam = async (teams) => {
  const pages = await Promise.all(teams.map((team) => searchSportLiveTvEvents(team, SPORT_LIVE_TV_SEARCH_LIMIT)));

  return { events: pages.flat(), hasNextPage: false, nextOffset: 0 };
};

export const getSportLiveTvSelectionEventsPage = (selection, status, loadedEvents, offset) => {
  if (selection.leagues.length) return fetchLeaguesPage(selection, status, loadedEvents, offset);
  if (selection.teams.length === 1) return fetchSingleTeamPage(selection.teams[0], loadedEvents);

  return fetchMultiTeam(selection.teams);
};

export const updateSportLiveTvPosition = (eventId, seconds) => axios.put(`/api/history/sport-livetv/position/${eventId}`, { position: seconds });

export const getSportLiveTvStreamLink = async (epgId) => {
  const { data } = await axios.get(`/api/play/livetv.epg/${epgId}.m3u8`);

  return data.data.secure_link;
};
